import React from 'react'
import PropTypes from 'prop-types'
import Style from './styleList'
import UserBadge from './component'

class UserBadgeList extends React.Component {
  renderBadge (user, index) {
    return <UserBadge
      key={user.username}
      id={user.id}
      name={user.name}
      username={user.username}
      showButton={!this.props.disabled}
      image={user.image}
      index={index}
      handleCloseButton={(event) => (this.props.handleCloseButton(index))}
    />
  }

  render () {
    const props = Object.assign({}, this.props)
    if (props.users.length <= 0) return null
    return (
      <Style>
        {props.users.map((user, index) => this.renderBadge(user, index))}
      </Style>
    )
  }
}

UserBadgeList.propTypes = {
  handleCloseButton: PropTypes.func.isRequired,
  users: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    username: PropTypes.string.isRequired,
    image: PropTypes.string
  }))
}

export default UserBadgeList
